import { UnknownSchema } from '../../constants'
import { SchemaDefinition } from '../../models/SchemaDefinition'

import type { SchemaBooleanSpecific } from '../../types'

export class SchemaBooleanDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaBooleanSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaBooleanSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaBooleanSpecific,
    path: PropertyKey[]
  ): SchemaBooleanSpecific {
    return {
      ...schema,
      type: 'Schema.Boolean',
      value: this.test(target, schema, path)
        ? (schema?.value ?? target)
        : target
    }
  }

  override inferOnlySchema(schema: SchemaBooleanSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaBooleanSpecific): string {
    const value = schema.value
    if (value !== undefined && this.test(value, schema))
      return JSON.stringify(value)
    return 'boolean'
  }

  override prune(target: boolean): boolean {
    return target
  }

  override transform(target: any, schema: SchemaBooleanSpecific) {
    if (target === null && schema.nullable) return target
    if (target === 'false') return false
    return Boolean(target ?? schema.fallback)
  }

  override validate(target: any, schema: SchemaBooleanSpecific): void {
    this.validateMetadata(target, schema, 'boolean')
  }
}
